import { getServiceDataWithDBHeaders, putServiceDataWithDBHeaders } from './Util';

const DBService = {

    apiWsUrl: 'https://api.vizfm.com/v1/',

    async getAts(week, symbol) {
        let url = this.apiWsUrl + 'ats';
        if (week !== undefined) {
            url += '/' + encodeURI(week);
        }
        if (symbol !== undefined) {
            url += '/' + encodeURI(symbol);
        }
        return getServiceDataWithDBHeaders(url);
    },

    async getAtsDistinctWeeks() {
        let url = this.apiWsUrl + 'atsDistinctWeeks';
        return getServiceDataWithDBHeaders(url);
    },

    async getAtsWeeklyTotal(week, symbol) {
        let url = this.apiWsUrl + 'atsWeeklyTotal';
        if (week !== undefined) {
            url += '/' + encodeURI(week);
        }
        return getServiceDataWithDBHeaders(url);
    },

    async getAtsWeeklyOnlyStockTotal(week, symbol) {
        let url = this.apiWsUrl + 'atsWeeklyTotal';
        if (week !== undefined) {
            url += '/' + encodeURI(week);
        }
        if (symbol !== undefined) {
            url += '/' + encodeURI(symbol);
        }
        return getServiceDataWithDBHeaders(url);
    },

    async getAtsStockWeeklyTotal(symbol, limit = 10) {
        let url = this.apiWsUrl + 'atsStockWeeklyTotal';
        if (symbol !== undefined) {
            url += '/' + encodeURI(symbol);
        }
        if (limit !== undefined) {
            url += '/' + encodeURI(limit);
        }
        return getServiceDataWithDBHeaders(url);
    },

    async getAtsAllWeeklyTotalForSelectedStock(symbol) {
        let url = this.apiWsUrl + 'atsAllWeeklyTotalForSelectedStock';
        if (symbol !== undefined) {
            url += '/' + encodeURI(symbol);
        }
        return getServiceDataWithDBHeaders(url);
    },

    async getAtsAllStocksWeeklyTotal(limit = 5) {
        let url = this.apiWsUrl + 'atsAllStocksWeeklyTotal';
        if (limit !== undefined) {
            url += '/' + encodeURI(limit);
        }
        return getServiceDataWithDBHeaders(url);
    },

    async getNewLow() {
        let url = this.apiWsUrl + 'newLow';
        return getServiceDataWithDBHeaders(url);
    },

    async getNewHigh() {
        let url = this.apiWsUrl + 'newHigh';
        return getServiceDataWithDBHeaders(url);
    },

    async getNew52Low() {
        let url = this.apiWsUrl + 'new52Low';
        return getServiceDataWithDBHeaders(url);
    },

    async getNew52High() {
        let url = this.apiWsUrl + 'new52High';
        return getServiceDataWithDBHeaders(url);
    },

    async getOverBought() {
        let url = this.apiWsUrl + 'overBought';
        return getServiceDataWithDBHeaders(url);
    },
    
    async getOverSold() {
        let url = this.apiWsUrl + 'overSold';
        return getServiceDataWithDBHeaders(url);
    },    

    async getUnusualVolume() {
        let url = this.apiWsUrl + 'unusualVolume';
        return getServiceDataWithDBHeaders(url);
    },

    async getMostVolatile() {
        let url = this.apiWsUrl + 'mostVolatile';
        return getServiceDataWithDBHeaders(url);
    },

    async getAdvanceDecline() {
        let url = this.apiWsUrl + 'advanceDecline';
        return getServiceDataWithDBHeaders(url);
    },

    async getHeatMap() {
        let url = this.apiWsUrl + 'heatMap';
        return getServiceDataWithDBHeaders(url);
    },

    async getSp500HeatMap() {
        let url = this.apiWsUrl + 'sp500HeatMap';
        return getServiceDataWithDBHeaders(url);
    },

    async getSectorPerformanceDay7() {
        let url = this.apiWsUrl + 'sectorPerformanceDay7';
        return getServiceDataWithDBHeaders(url);
    },

    async getSectorPerformanceDay30() {
        let url = this.apiWsUrl + 'sectorPerformanceDay30';
        return getServiceDataWithDBHeaders(url);
    },

    async getSectorPerformanceDay90() {
        let url = this.apiWsUrl + 'sectorPerformanceDay90';
        return getServiceDataWithDBHeaders(url);
    },

    async getSectorPerformanceDay180() {
        let url = this.apiWsUrl + 'sectorPerformanceDay180';
        return getServiceDataWithDBHeaders(url);
    },

    async getSectorPerformanceDay365() {
        let url = this.apiWsUrl + 'sectorPerformanceDay365';
        return getServiceDataWithDBHeaders(url);
    },

    async userSignup(body) {
        let url = this.apiWsUrl + 'user/create';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userSignin(body) {
        let url = this.apiWsUrl + 'user';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userUpdate(body) {
        let url = this.apiWsUrl + 'user/update';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userConfirmUserid(body) {
        let url = this.apiWsUrl + 'user/confirmUserId';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userVerifyUserid(body) {
        let url = this.apiWsUrl + 'user/verifyUserId';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userForgotPassword(body) {
        let url = this.apiWsUrl + 'user/forgotPassword';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userPortfolio(body) {
        let url = this.apiWsUrl + 'userPortfolio';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userPortfolioDistincName(body) {
        let url = this.apiWsUrl + 'userPortfolio/distinctName';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userPortfolioCreate(body) {
        let url = this.apiWsUrl + 'userPortfolio/create';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userPortfolioUpdate(body) {
        let url = this.apiWsUrl + 'userPortfolio/update';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userPortfolioDelete(body) {
        let url = this.apiWsUrl + 'userPortfolio/delete';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userNewsNotifications(body) {
        let url = this.apiWsUrl + 'user/newsNotifications';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userNewsNotificationsDelete(body) {
        let url = this.apiWsUrl + 'user/newsNotificationsDelete';
        return putServiceDataWithDBHeaders(url, body);
    },

    async newsKeywordsSettings(body) {
        let url = this.apiWsUrl + 'user/newsKeywordsSettings';
        return putServiceDataWithDBHeaders(url, body);
    },

    async newsKeywordsCreateSettings(body) {
        let url = this.apiWsUrl + 'user/newsKeywordsCreateSettings';
        return putServiceDataWithDBHeaders(url, body);
    },

    async newsKeywordsUpdateSettings(body) {
        let url = this.apiWsUrl + 'user/newsKeywordsUpdateSettings';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userPortfolioAverage(body) {
        let url = this.apiWsUrl + 'userPortfolioAverage';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userPortfolioAverageCreate(body) {
        console.log('create', body);
        let url = this.apiWsUrl + 'userPortfolioAverage/create';
        return putServiceDataWithDBHeaders(url, body);
    },

    async userPortfolioAverageUpdate(body) {
        console.log('update', body);
        let url = this.apiWsUrl + 'userPortfolioAverage/update';
        return putServiceDataWithDBHeaders(url, body);
    },

}
export default DBService;